<template>
  <div class="page-container">
    <div id="preViewPdf"></div>
  </div>
</template>

<script>
import { getCertificateDetail, refreshOauth } from '@/service/system/licence.js'
import { ImagePreview, Toast } from 'vant'
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import { parseTime } from '@/utils/tools.js'
import * as tokenUtils from '@/utils/TokenUtils'
const clientId = process.env.VUE_APP_MODE == 'production' ? 'ae3c25a0329ae4c5096050635f68045b' : '908a26e65bc3a2547ea8ac3dc916c6fd'
export default {
  data() {
    return {
      detailImgs: [],
      pdfBase64: '',
      pdfh5: null,
      info: {}
    }
  },
  computed: {
    typeId() {
      return this.$route.query.typeId ?? -1
    }
  },
  created() {
    if (this.typeId > 0) {
      document.title = ['身份证', '户口簿证', '驾驶证', '结婚证', '行驶证', '居住证'][this.typeId - 1]
    }
  },
  mounted() {
    this.loadingDetailImgs()
  },
  beforeRouteLeave(to, from, next) {
    // 去除js文件的引入
    var script = Array.from(document.getElementsByTagName('script')).find((script) => {
      let src = script.getAttribute('src')
      return src && src.startsWith('/lib/watermark.js')
    })
    console.log(script)
    if (script) {
      script.remove()
    }
    // 去除页面的对应dom元素
    // const otdivid = document.getElementById('otdivid')
    // otdivid.remove()
    if (window.watermark) {
      window.watermark.remove()
    }
    next()
  },
  methods: {
    // 刷新token
    async refreshToken(cb) {
      try {
        const res = await refreshOauth(clientId, tokenUtils.getRefreshToken())
        tokenUtils.setRefreshToken(res.refreshToken)
        tokenUtils.setAppToken(res.token)
        if (cb) {
          cb()
        }
      } catch (err) {
        console.log(err)
      }
    },
    openPreview(index) {
      ImagePreview({
        images: this.detailImgs,
        startPosition: index
      })
    },
    async loadingDetailImgs() {
      try {
        const data = await getCertificateDetail(Number(this.typeId))
        if (this.typeId == 1) {
          this.pdfBase64 = 'data:application/pdf;base64,' + data.pdf
        } else if (this.typeId == 2) {
          this.pdfBase64 = 'data:application/pdf;base64,' + data.residenceBookletMember.pdf
        } else if (this.typeId == 3) {
          this.pdfBase64 = 'data:application/pdf;base64,' + data.pdf
        } else if (this.typeId == 4) {
          this.pdfBase64 = 'data:application/pdf;base64,' + data.pdf
        }
        this.info = data
        this.openPdf()
      } catch (err) {
        if (err.code == 60301) {
          this.refreshToken(this.loadingDetailImgs)
        } else {
          Toast.fail(err)
        }
      }
    },
    openPdf() {
      const that = this
      this.pdfh5 = new Pdfh5('#preViewPdf', { pdfurl: this.pdfBase64, renderType: 'svg' })
      // this.pdfh5.on('ready', function () {
      // })
      this.pdfh5.on('complete', function () {
        // 添加水印
        that.addWatermark()
        // const ele = document.getElementById('wm_div_id').shadowRoot
        // let style_node = document.createElement('style')
        // style_node.innerHTML = 'div {color: red;}'
        // ele.append(style_node)
        // setTimeout(() => {
        //   watermark.remove()
        // }, 5000)
      })
    },
    addWatermark() {
      const that = this
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = '/lib/watermark.js'
      document.getElementById('app').appendChild(script)
      script.onload = function () {
        document.getElementsByClassName('pdfViewer')[0].id = 'watermarkWrap'
        window.watermark.init({
          watermark_txt: `${that.info.name || that.info.citizenName || that.info.owner || that.info.residenceBookletMember.citizenName || ''}\n${parseTime(new Date())}\ni高新`,
          watermark_parent_node: 'watermarkWrap',
          watermark_fontsize: '12px',
          watermark_rows: 3,
          watermark_cols: 3,
          watermark_width: 140,
          watermark_x_space: 10
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-container {
  width 100%
  height 100%
  overflow hidden auto
  padding 30px
  #preViewPdf {
    // width 100%
    // height 100%
  }
  .detial-image {
    width 100%
    height auto
    display block
    border-radius 10px
  }
  .detial-image+.detial-image {
    margin-top 30px
  }
}
</style>
